<mat-list style="overflow-y: scroll;height: 173px;">
      <mat-list-item *ngFor="let item of eventList" >{{item.title}}</mat-list-item>
</mat-list>
<mat-list-item><span class="goToLink"><b (click)="goToEvents()"><br/> {{ 'DASHBOARD.myDashboard.viewMore' | translate }} ></b></span></mat-list-item>

